import { z } from "zod";
import { PublicIdSchema } from "./common";

export const InspectionItemResult = z.enum(["ok", "ng", "na"]);

/** 点検結果 (項目別) の表示ラベル。ok=OK / ng=NG / na=対象外。driver / admin / CSV で共用する。 */
export const INSPECTION_ITEM_RESULT_LABELS = {
  ok: "OK",
  ng: "NG",
  na: "対象外",
} as const satisfies Record<z.infer<typeof InspectionItemResult>, string>;

/**
 * 車両点検の保存キーと画面表示名の対応。driver / admin / 通知で同じ項目名を使う。
 */
export const VEHICLE_INSPECTION_ITEM_LABELS = {
  item1: "ブレーキ",
  item2: "タイヤ",
  item3: "ランプ類",
  item4: "ミラー",
  item5: "ワイパー",
  item6: "オイル",
  item7: "冷却水",
  item8: "バッテリー",
  item9: "ベルト類",
  item10: "排気音",
  item11: "警告灯",
  item12: "ホーン",
} as const;

export const VehicleInspectionItems = z.object({
  item1: InspectionItemResult,
  item2: InspectionItemResult,
  item3: InspectionItemResult,
  item4: InspectionItemResult,
  item5: InspectionItemResult,
  item6: InspectionItemResult,
  item7: InspectionItemResult,
  item8: InspectionItemResult,
  item9: InspectionItemResult,
  item10: InspectionItemResult,
  item11: InspectionItemResult,
  item12: InspectionItemResult,
});

export const VehicleInspection = z.object({
  public_id: PublicIdSchema,
  attendance_public_id: PublicIdSchema,
  vehicle_public_id: PublicIdSchema,
  ...VehicleInspectionItems.shape,
  notes: z.string().nullable(),
  inspected_at: z.iso.datetime({ offset: true }),
});

export const CreateVehicleInspectionInput = z.object({
  vehicle_public_id: PublicIdSchema,
  ...VehicleInspectionItems.shape,
  notes: z.string().optional(),
});

export type VehicleInspectionDto = z.infer<typeof VehicleInspection>;
export type VehicleInspectionItemsDto = z.infer<typeof VehicleInspectionItems>;
export type VehicleInspectionItemKey = keyof VehicleInspectionItemsDto;
export type CreateVehicleInspectionInputDto = z.infer<typeof CreateVehicleInspectionInput>;
export type InspectionItemResultDto = z.infer<typeof InspectionItemResult>;
